import { VaultActions } from "./actions";
import { Actions } from "@my-dld/actions";
import { defaultContext, VaultData } from "./VaultContext";
import { AnyAction } from "redux";

const defaultState: VaultData = defaultContext;
export { defaultState as DefaultState };

export function VaultReducer( state = defaultState, action: AnyAction ) {

	switch ( action.type ) {
		case VaultActions.UPDATE_VAULT:
		case Actions.USER_LOGGED_OUT:
			return { ...state, ...action.payload };
		case VaultActions.RESET_VAULT:
			return {
				...defaultState,
			};
		default:
			return state;
	}
}
